import {Injectable} from '@angular/core';
import {Observable} from "rxjs";

import {Http, Headers, Response} from '@angular/http';


export interface Info {
  title: string,
  description: string,
  isToggle: boolean,
  text: string;
}

@Injectable()
export class EditDataService {
  password: any;
  defaultData: any;
  prolongation: any;
  config: {
    unlockInactiveIndentureAfterPortmone: number
  };

  constructor(private http: Http) {
    this.http.get('/api/config').subscribe(
      data => {
        this.defaultData = JSON.parse(data["_body"]);
      }
    );
  }



  setPassword(password) {
    this.password = password;
  };

  getPassword() {
    return this.password
  };

  getData() {
    return this.http.get('/api/config')
      .map(
        (res: Response) => res.json()
      );
  };



  // region Admin
  getProlongation() {
    return this.http.get('/api/export?password=' + this.password)
  };

  getFiliations() {
    return this.http.get('/api/filiations?password=' + this.password).toPromise();
  };

  getPayorders() {
    return this.http.get('/api/payorders?password=' + this.password).toPromise();
  };

  sendNewFiliation(filiation: any) {
    return this.http.post('/api/filiation', {filiation: filiation, password: this.password}).toPromise();
  };

  sendFiliation(newData :any) {
    return this.http.put('/api/filiation', {filiation: newData, password: this.password}).toPromise();
  };

  sendRemoveFiliation(item: any) {
    return this.http.delete('/api/filiation?password=' + this.password + '&id=' + item.id + '&filiationId=' + item.filiationId).toPromise();
  };

  sendRemovePayorder(item: any) {
    return this.http.delete('/api/payorder?password=' + this.password + '&id=' + item.id ).toPromise();
  };

  getDataObject() {
    return this.defaultData;
  };

  updateConfig(config :any) {
    return this.http.put('/api/admin/config', {properties: config, password: this.password}).toPromise()
      .then(function (response) {
        return response.json();
      })
      .catch(error => {
        console.log(error);
      });
  };

  getMaintenanceStatus() {
    return this.http.get('/api/admin/maintenance?password=' + encodeURIComponent(this.password))
      .map((response: Response) => response.json());
  };

  updateMaintenanceStatus(enabled: boolean, message: string) {
    return this.http.put('/api/admin/maintenance', {
      enabled: enabled,
      message: message,
      password: this.password
    }).map((response: Response) => response.json());
  };

  getDataAdmin() {
    /*return this.defaultData;*/
    this.http.get('/api/config')
    /*.map((res: Response) => res.json());*/
      .subscribe(
        data => {
          this.defaultData = JSON.parse(data["_body"]);
        }
      );
    return this.defaultData;
  };

  public SendReqForProlongations(filiationId: any, password: any): Observable<any> {
    if (filiationId !== -1) {
      return this.http.post('/api/export', {filiationId: filiationId, password: password});
    }
    return this.http.post('/api/export', {password: password});
  };

  public setSettings(logo: any, background: any): Observable<any> {
    let formData = new FormData();
    let headers = new Headers();
    headers.append('Content-Type', 'multipart/form-data');
    formData.append("password", this.password);
    formData.append("properties", JSON.stringify(this.defaultData));
    formData.append("background", background);
    formData.append("logo", logo);
    return this.http.post('/api/admin/config', formData, headers)
  };

 //endregion

  //region Editing
  editData(index, title, description) {
    this.defaultData.rules[index].title = title;
    this.defaultData.rules[index].description = description;
  }

  editFooter(footer) {
    this.defaultData.footer = footer;
  }

  editModal(modal) {
    this.defaultData.modal = modal;
  }

  editSuccess(successPage) {
    this.defaultData.successPage = successPage;
  }

  editFail(failPage) {
    this.defaultData.failPage = failPage;
  }
  //endregion
}



// WEBPACK FOOTER //
// /home/backend/KreditCentr/WebLombard/client/src/app/services/edit-data.service.ts